// import $ from "jquery";
// import moment from "moment";
// import "moment/locale/ja";
// import "tempusdominus-bootstrap-4";
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n/ja";
import "flatpickr/dist/flatpickr.min.css";
import {
  format as dateFnsFormat,
  parse as dateFnsParse,
  isEqual as dateFnsIsEqual,
  startOfMonth as dateFnsStartOfMonth,
  subDays as dateFnsSupDays,
  subMonths as dateFnsSubMonths,
  addMonths as dateFnsAddMonths,
  addYears as dateFnsAddYears
} from "date-fns";
import { format as d3Format } from "d3-format";

const emit = (vnode, name, data) => {
  vnode.context.$emit(name, data);
};

const isDate = strDate => {
  // 空文字は無視
  if (strDate == "") {
    return true;
  }
  // 年/月/日の形式のみ許容する
  if (!(strDate || "").match(/^\d{4}\/\d{2}\/\d{2}$/)) {
    return false;
  }

  // 日付変換された日付が入力値と同じ事を確認
  // new Date()の引数に不正な日付が入力された場合、相当する日付に変換されてしまうため
  //
  var date = new Date(strDate);
  if (
    date.getFullYear() != strDate.split("/")[0] ||
    date.getMonth() != strDate.split("/")[1] - 1 ||
    date.getDate() != strDate.split("/")[2]
  ) {
    return false;
  }

  return true;
};

const getCalendarData = async (vnode, instance, forceChange = false) => {
  const year = instance.currentYear;
  const $month = instance.element.querySelector("input[data-input-month]");
  const $day = instance.element.querySelector("input[data-input-day]");

  let inputDate = null;
  let month = null;
  if ($month && $day) {
    month = d3Format("02d")($month.value - 0);
    const day = d3Format("02d")($day.value - 0);
    const dateStr = `${year}/${month}/${day}`;
    if (isDate(dateStr)) {
      inputDate = dateFnsParse(dateStr);
    }
  }

  if (inputDate === null && forceChange === false) {
    if (month !== "00") {
      const year = new Date().getFullYear();
      const dateStr = `${year}/${month}/01`;
      instance.jumpToDate(dateStr);
    } else {
      instance.jumpToDate(new Date());
    }
  }

  const target_ym = dateFnsFormat(
    new Date(instance.currentYear, instance.currentMonth, 1),
    "YYYYMM"
  );

  const sendData = {
    target_ym
  };
  if (vnode.context.coop_no) {
    sendData.coop_no = vnode.context.coop_no;
  }
  if (vnode.context.tehaisaki_kbn) {
    sendData.tehaisaki_kbn = vnode.context.tehaisaki_kbn;
  }

  const response = await vnode.context.$root.postAsteria(
    "CommonAPI",
    "getNDCSCalendar",
    sendData
  );

  if (response.responseData.return != 0) {
    if (response.responseData.return != 9) {
      window.alert("カレンダーデータの取得に失敗しました");
    }
  }

  const dateList = vnode.context.$root.getAsteriaArray(
    response.responseData,
    "calendarData"
  );

  const enableDates = dateList
    .filter(row => row.ok_fg)
    .map(row => {
      const today = new Date(
        instance.currentYear,
        instance.currentMonth,
        parseInt(row.day)
      );
      return today;
    });
  if (!enableDates.length) {
    enableDates.push(new Date(1900, 1, 1));
  }
  instance.set("enable", enableDates);

  if (
    inputDate &&
    enableDates.some(date => {
      return dateFnsIsEqual(inputDate, date);
    })
  ) {
    instance.setDate(inputDate);
  }
};

const DateTimePicker = {
  install(Vue) {
    Vue.directive("datetime-picker", {
      bind: (el, binding, vnode) => {
        var plusYears = 2; //ND・ニトムズ以外はカレンダー表示＋2年
        if ((vnode.context.coop_no == '2') || (vnode.context.coop_no == '4')
          || (vnode.context.coop_no == null && vnode.context.tehaisaki_kbn == null)
          || (vnode.context.tehaisaki_kbn == 'N010') || (vnode.context.tehaisaki_kbn == 'N008')) {
          plusYears = 1;
        }
        const isApi = binding.value;
        const isPast = binding.arg == "past" ? true : false;
        const minDay = dateFnsAddMonths(new Date(), -6);
        const maxDay = dateFnsSupDays(
          dateFnsAddYears(
            dateFnsSubMonths(dateFnsStartOfMonth(new Date()), -2),
            plusYears
          ),
          1
        );

        flatpickr(el, {
          allowInput: true,
          wrap: true,
          locale: "ja",
          dateFormat: "Y/m/d",
          clickOpens: false,
          minDate: isApi ? "today" : isPast ? minDay : null,
          maxDate: isApi ? maxDay : isPast ? "today" : null,
          onOpen: async (_selectedDates, _dateStr, instance) => {
            if (isApi) {
              await getCalendarData(vnode, instance);
            }
          },
          onMonthChange: async (_selectedDates, _dateStr, instance) => {
            if (isApi) {
              await getCalendarData(vnode, instance, true);
            }
          },
          onYearChange: async (_selectedDates, _dateStr, instance) => {
            if (isApi) {
              await getCalendarData(vnode, instance, true);
            }
          },
          onChange: date => {
            if (isApi) {
              emit(vnode, "input", dateFnsFormat(date, "YYYY/MM/DD"));
            }
          }
        });

        if (isApi) {
          const input = el.querySelector("input[data-input]");

          if (input.value) {
            let year, month, day, dateStr;

            if (
              (input.value || "").match(/^[0-9]{2}\/[0-9]{1,2}\/[0-9]{1,2}/)
            ) {
              [year, month, day] = input.value
                .split("/")
                .map(el => parseInt(el));
              year += 2000;

              dateStr = `${year}/${month}/${day}`;
            } else {
              dateStr = input.value;
            }

            if (isDate(dateStr)) {
              emit(vnode, "input", dateStr);
            }
          }
        } else {
          const input = el.querySelector("input[data-input]");
          if (!input) {
            return;
          }

          input.addEventListener("keydown", e => {
            // Enterキー除外
            if (e.keyCode === 13) {
              e.preventDefault();
              e.stopPropagation();

              return false;
            }
          });
        }
      }
    });
  }
};

export default DateTimePicker;
